export default "__VITE_ASSET__UorT$VNt__"